<div class="container-fuild">
  <div class="w-100 overflow-hidden position-relative flex-wrap d-block vh-100">
    <div class="row">
      <div class="col-lg-5">
        <div
          class="d-lg-flex align-items-center justify-content-center d-none flex-wrap vh-100 bg-primary-transparent"
        >
          <div>
            <img src="../../../../assets/img/bg/authentication-bg-06.svg" alt="Img" />
          </div>
        </div>
      </div>
      <div class="col-lg-7 col-md-12 col-sm-12">
        <div class="row justify-content-center align-items-center vh-100 overflow-auto flex-wrap">
          <div class="col-md-7 mx-auto vh-100">
            <form [formGroup]="form" class="vh-100">
              <div class="vh-100 d-flex flex-column justify-content-between p-4 pb-0">
                <div class="mx-auto mb-5 text-center">
                  <img src="../../../../assets/img/logo/logo.webp " class="img-fluid" alt="Logo" />
                </div>
                <div class="" *ngIf="isTokenValid; else invalidToken">
                  <!-- <div class="text-center mb-3">
                    <h2 class="mb-2">Reset Password</h2>
                    <p class="mb-0">
                      Your new password must be different from previous used passwords.
                    </p>
                  </div> -->
                  <div class="text-center mb-3">
                    <h2 class="mb-2">{{ isFirstTime ? 'Set Password' : 'Reset Password' }}</h2>
                    <p class="mb-0">
                      {{
                        isFirstTime
                          ? 'Create a password for your new account.'
                          : 'Your new password must be different from previous used passwords.'
                      }}
                    </p>
                  </div>
                  <div>
                    <div class="input-block mb-3">
                      <div class="mb-3">
                        <label class="form-label" for="password">Password</label>
                        <div class="pass-group" id="passwordInput">
                          <input
                            [type]="passwordVisible ? 'text' : 'password'"
                            class="form-control pass-input"
                            formControlName="password"
                            appTrimInput
                            (input)="onPasswordInput($event)"
                          />
                          <span
                            [class]="
                              passwordVisible
                                ? 'ti toggle-password ti-eye-off'
                                : 'ti toggle-password ti-eye'
                            "
                            id="toggle-password"
                            role="button"
                            tabindex="0"
                            (click)="togglePasswordVisibility()"
                            (keydown.enter)="togglePasswordVisibility()"
                            (keydown.space)="togglePasswordVisibility()"
                          ></span>
                        </div>

                        <div *ngIf="form.get('password')?.invalid && form.get('password')?.touched">
                          <span class="text-danger">
                            {{ getErrorMessage('password') }}
                          </span>
                        </div>
                        <div
                          *ngIf="
                            form.get('password')?.invalid &&
                            (form.get('password')?.touched || form.get('password')?.dirty)
                          "
                        >
                          <div *ngIf="form.get('password')?.errors?.['required']">
                            Password Required
                          </div>
                          <div *ngIf="form.get('password')?.errors?.['minlength']">
                            Minimum length is 8 characters
                          </div>
                          <div
                            *ngIf="
                              form.hasError('passwordsDoNotMatch') &&
                              form.get('confirmPassword')?.touched
                            "
                          >
                            <span class="text-danger">Passwords do not match</span>
                          </div>
                        </div>
                      </div>
                      <div class="password-strength d-flex" id="passwordStrength">
                        <!-- <span id="poor"></span>
                        <span id="weak"></span>
                        <span id="strong"></span>
                        <span id="heavy"></span> -->
                        <span
                          [class]="
                            passwordStrength === 'poor'
                              ? 'bg-danger'
                              : passwordStrength === 'weak'
                                ? 'bg-warning'
                                : passwordStrength === 'medium'
                                  ? 'bg-info'
                                  : passwordStrength === 'strong'
                                    ? 'bg-success'
                                    : ''
                          "
                        ></span>
                        <span
                          [class]="
                            passwordStrength === 'weak'
                              ? 'bg-warning'
                              : passwordStrength === 'medium'
                                ? 'bg-info'
                                : passwordStrength === 'strong'
                                  ? 'bg-success'
                                  : ''
                          "
                        ></span>
                        <span
                          [class]="
                            passwordStrength === 'medium'
                              ? 'bg-info'
                              : passwordStrength === 'strong'
                                ? 'bg-success'
                                : ''
                          "
                        ></span>
                        <span [class]="passwordStrength === 'strong' ? 'bg-success' : ''"></span>
                      </div>
                      <div id="passwordInfo" class="mb-2"></div>
                      <p class="fs-12">
                        Use 8 or more characters with a mix of letters, numbers & symbols.
                      </p>
                    </div>
                    <div class="mb-3">
                      <label class="form-label" for="confirmPassword">Confirm Password</label>
                      <div class="pass-group" id="confirmPasswordInput">
                        <input
                          appTrimInput
                          [type]="confirmPasswordVisible ? 'text' : 'password'"
                          class="form-control pass-input"
                          formControlName="confirmPassword"
                          appTrimInput
                          (input)="onPasswordInput($event)"
                        />
                        <span
                          [class]="
                            confirmPasswordVisible
                              ? 'ti toggle-password ti-eye-off'
                              : 'ti toggle-password ti-eye'
                          "
                          id="toggle-confirmpassword"
                          role="button"
                          tabindex="0"
                          (click)="toggleConfirmPasswordVisibility()"
                          (keydown.enter)="togglePasswordVisibility()"
                          (keydown.space)="togglePasswordVisibility()"
                        ></span>
                      </div>
                    </div>
                    <div class="mb-3">
                      <button
                        type="submit"
                        class="btn btn-primary w-100"
                        [disabled]="!form.valid"
                        (click)="onSubmit()"
                      >
                        <ng-container *ngIf="isLoading$ | async; else loading">
                          <span
                            class="spinner-border spinner-border-sm me-2"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          Submit...
                        </ng-container>
                        <ng-template #loading> Submit </ng-template>
                      </button>
                    </div>
                  </div>
                </div>
                <ng-template #invalidToken>
                  <div class="invalid-token-container">
                    <div class="card text-center p-4">
                      <h2 class="text-danger">⚠️ Invalid or Expired Link</h2>
                      <p>The password reset link is either invalid or has already been used.</p>
                      <p>You can request a new one below.</p>
                      <div class="d-flex justify-content-center mt-3">
                        <a routerLink="/auth/forgot-password" class="btn btn-primary w-50">
                          Request New Reset Link
                        </a>
                      </div>
                    </div>
                  </div>
                </ng-template>
                <div class="mt-5 pb-4 text-center">
                  <p class="mb-0 textt-gray-9" [innerHTML]="copyrightText"></p>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
